<template>
  <div>
    <div class="titles">
      添加权限
      <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">名称：</div>
        <Input v-model="name" placeholder="请输入顶级权限名称..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">图标：</div>
        <Input v-model="icon" placeholder="请输入菜单权限图标..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">顺序：</div>
        <Input v-model="order" placeholder="请输入顶级权限顺序..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">子级：</div>
        <Input v-model="zjName" placeholder="请输入子级权限名称..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">地址：</div>
        <Input v-model="url" placeholder="请输入子级跳转地址..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">顺序：</div>
        <Input v-model="zjOrder" placeholder="请输入子级权限顺序..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div style="width: 100%;display: flex;justify-content: center">
      <Button :loading="loading" type="success" class="qx09" @click="addAuth" v-on:keyup.13="addAuth()">提交</Button>
    </div>
  </div>
</template>

<script>
  import httpAuth from '@/api/auth';
  export default {
    name: "AddAuth",
    data(){
      return{
        name:'',        //顶级权限名称
        icon:'',        //图标地址
        order:'',       //顶级权限顺序
        zjName:'',      //子级权限名称
        zjOrder:'',     //子级权限顺序
        url:'',         //子级权限地址
        loading:false,  //按钮是否加载
      }
    },
    created() {
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.addAuth();
        }
      }
    },
    mounted() {
    },
    methods:{
      back(){
        var me = this;
        me.$router.back();
      },
      addAuth(){//添加权限
        var me = this;
        if (me.name === '') {
          me.$message.error('请输入顶级权限名称');
          return false;
        }
        if (me.icon === '') {
          me.$message.error('请输入菜单权限图标');
          return false;
        }
        if (me.order === '') {
          me.$message.error('请输入顶级权限顺序');
          return false;
        }
        if (me.zjName === '') {
          me.$message.error('请输入子级权限名称');
          return false;
        }
        if (me.zjOrder === '') {
          me.$message.error('请输入子级权限顺序');
          return false;
        }
        if (me.url === '') {
          me.$message.error('请输入子级权限地址');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          name: me.name,
          icon: me.icon,
          code: me.order,
          pid: 0,
          mobile: user.mobile,
          sign: user.sign,
          type:0
        }
        me.loading = true;
        httpAuth.addAuth(data).then(res => {
          if (res.code == "1111") {
            me.loading = false;
            me.$message.error("系统错误");
          } else {
            let datas = {
              name:me.zjName,
              url:me.url,
              pid:res.data.id,
              mobile: user.mobile,
              sign: user.sign,
              type:0,
              code: me.zjOrder,
            }
            httpAuth.addAuth(datas).then(ress => {
              if (res.code == "1111") {
                me.loading = false;
                me.$message.error("系统错误");
              } else {
                me.loading = false;
                me.$message.success('添加成功');
                setTimeout(function () {
                  me.$router.back();
                },1500)
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import "AuthList.css";
</style>
